function UnderConstruction() {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 text-gray-800">
        <h1 className="text-4xl font-bold text-blue-600 mb-4">🚧 Under Construction 🚧</h1>
        <p className="text-lg mb-6">This page is currently being built. Please check back soon!</p>
        <a
          href="/"
          className="text-blue-600 hover:underline"
        >
          Go back to Home
        </a>
      </div>
    );
  }
  
  export default UnderConstruction;  